import React, { Component } from 'react'
import PropTypes from 'prop-types'
import style from './style'
import ResetPasswordForm from '../ResetPasswordFrom'
import { assets, translations } from '../../../config'
import P from '../../../components/P'
import H2 from '../../../components/H2'


class ResetPasswordScreen extends Component {
  state = {
    submitted: false
  }
  onSubmissionComplete = () => {
    this.setState({ submitted: true })
  }
  render = () => {
    return (
      <div style={style.container}>
      <div style={style.formContainer}>
        <div style={style.logoContainer}>
          <img style={style.logo} src={assets.logo} alt={'Logo'} />
        </div>
       {this.state.submitted
        ? <div>
          <div style={style.checkContainer}>
            <img style={style.logo} src={assets.checkcircle} alt={'Circle'}/>
          </div>
          <div style={style.header}>
            <H2 value={translations('Password Reset')} />
          </div>
          <div style={style.textContainer}>
            <P value={translations('If you have reset a password for another user, please make sure you notify them directly.')} />
          </div>
        </div>
        :<div>
          <ResetPasswordForm onSubmissionComplete={this.onSubmissionComplete} />
        </div>
       }
      </div>
    </div>

    )
  }
}


ResetPasswordScreen.propTypes = {
  onSubmissionComplete: PropTypes.func
}

export default ResetPasswordScreen


// WEBPACK FOOTER //
// ./src/containers/ResetPassword/ResetPasswordScreen/ResetPasswordScreen.js